import {Directive, HostBinding, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[dragStartStop]',
  standalone: false,
})
export class DragStartStopDirective {
  @Input() item: {id: string} | undefined;

  @HostBinding('style.opacity') private styleOpacity = '1';

  @HostListener('dragstart', ['$event']) public onDragStart(event: DragEvent) {
    if (this.item?.id) {
      event.dataTransfer?.setData('text/plain', this.item.id);
    }
    this.styleOpacity = '0.4';
  }

  @HostListener('dragend', ['$event']) public onDragEnd(event: DragEvent) {
    this.styleOpacity = '1';
  }
}
